import UserCreate from "./user-create";

export default UserCreate;
